export default __webpack_public_path__ + "static/media/SIAM_2021_RLDynamicConvexRisk.08d9337b.pdf";